import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import {
  COURSE_FEATURE_KEY,
  CourseState,
  courseAdapter,
} from './course.reducer';

export const selectCourseState =
  createFeatureSelector<CourseState>(COURSE_FEATURE_KEY);

const { selectAll } = courseAdapter.getSelectors();

export const selectAllCourses = createSelector(
  selectCourseState,
  (state: CourseState) => selectAll(state),
);

export const selectGetCoursesCallState = createSelector(
  selectCourseState,
  (state: CourseState) => state.getCoursesCallState,
);

export const selectCoursesFinishedLoading = createSelector(
  selectGetCoursesCallState,
  (callState: CallState) =>
    callState !== LoadingState.INIT && callState !== LoadingState.LOADING,
);
